import { QuizQuestion } from '../../api/quiz-services';
import { module1Questions } from '../module-1/assessment';
import { module2Questions } from '../module-2/assessment';
import { module3Questions } from '../module-3/assessment';
import { module4Questions } from '../module-4/assessment';
import { module5Questions } from '../module-5/assessment';
import { module6Questions } from '../module-6/assessment';
import { module7Questions } from '../module-7/assessment';
import { module8Questions } from '../module-8/assessment';
import { module9Questions } from '../module-9/assessment';
import { module10Questions } from '../module-10/assessment';

/**
 * Central Question Bank
 * Aggregates all module-specific assessments for curriculum synchronization.
 * Each module provides 20 questions.
 */
export const questionBank: QuizQuestion[] = [
    ...module1Questions,
    ...module2Questions,
    ...module3Questions,
    ...module4Questions,
    ...module5Questions,
    ...module6Questions,
    ...module7Questions,
    ...module8Questions,
    ...module9Questions,
    ...module10Questions
];

/**
 * Helper to retrieve a single question by its unique ID.
 */
export const getQuestionById = (id: string): QuizQuestion | undefined => {
    return questionBank.find(q => q.id === id);
};

/**
 * Helper to get the first 10 questions for a module's mastery quiz.
 * Static mapping ensures consistency across retakes.
 */
export const getMasteryQuestions = (moduleId: string): QuizQuestion[] => {
    return questionBank
        .filter(q => q.moduleId === moduleId)
        .slice(0, 10);
};

/**
 * Helper to get a random selection of questions from a range of modules.
 * Used for review quizzes spanning multiple modules.
 */
export const getReviewQuestions = (moduleIds: string[], count: number = 20): QuizQuestion[] => {
    const basePerModule = Math.floor(count / moduleIds.length);
    let remainder = count % moduleIds.length;
    
    const combinedPool: QuizQuestion[] = [];
    
    for (const moduleId of moduleIds) {
        const modulePool = questionBank.filter(q => q.moduleId === moduleId);
        
        // Shuffle the module's questions first (Fisher-Yates)
        const shuffledModule = [...modulePool];
        for (let i = shuffledModule.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [shuffledModule[i], shuffledModule[j]] = [shuffledModule[j], shuffledModule[i]];
        }
        
        // Draw the appropriate number of questions
        let drawCount = basePerModule;
        if (remainder > 0) {
            drawCount += 1;
            remainder -= 1;
        }
        
        combinedPool.push(...shuffledModule.slice(0, drawCount));
    }
    
    // Shuffle the combined pool (Fisher-Yates) so they are fully mixed
    const shuffledResult = [...combinedPool];
    for (let i = shuffledResult.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [shuffledResult[i], shuffledResult[j]] = [shuffledResult[j], shuffledResult[i]];
    }
    
    return shuffledResult;
};
